import { PDFDocument, rgb, StandardFonts } from "pdf-lib"; // Import StandardFonts
import { formatDate } from "../lib/formatDate";

const editPdf = async (data, acceptedDate) => {
  if (!data) return;
  try {
    const response = await fetch("/page.pdf"); // Fetch the original PDF template
    const pdfBytes = await response.arrayBuffer();

    const pdfDoc = await PDFDocument.load(pdfBytes);
    const pages = pdfDoc.getPages();
    const firstPage = pages[0];

    // Load standard fonts from pdf-lib
    const helveticaFont = await pdfDoc.embedFont(StandardFonts.Helvetica);
    const helveticaBoldFont = await pdfDoc.embedFont(
      StandardFonts.HelveticaBold
    );

    // Wrapping and drawing text dynamically
    function wrapText(text, maxWidth, font, size) {
      const words = text.split(" ");
      let line = "";
      const lines = [];

      words.forEach((word) => {
        const testLine = line + word + " ";
        const testWidth = font.widthOfTextAtSize(testLine, size);
        if (testWidth > maxWidth) {
          lines.push(line.trim());
          line = word + " ";
        } else {
          line = testLine;
        }
      });
      lines.push(line.trim());
      return lines;
    }

    // Centered Project Name
    const { width } = firstPage.getSize();
    const projectNameLines = wrapText(
      data.projectName,
      300,
      helveticaBoldFont,
      22
    );

    let projectNameY = 630;
    projectNameLines.forEach((line) => {
      const textWidth = helveticaBoldFont.widthOfTextAtSize(line, 22);
      const textX = (width - textWidth) / 2; // Center align horizontally
      firstPage.drawText(line, {
        x: textX,
        y: projectNameY,
        size: 22,
        font: helveticaBoldFont,
        color: rgb(0, 0, 0),
      });
      projectNameY -= 26;
    });

    // Sent & Accepted in two columns
    const columnY = projectNameY - 20;
    firstPage.drawText(`Sent: ${formatDate(data.dateSent)}`, {
      x: 180,
      y: columnY,
      size: 10,
      font: helveticaFont,
      color: rgb(0.4, 0.4, 0.4),
    });

    firstPage.drawText(`Accepted: ${formatDate(acceptedDate) || "-----"}`, {
      x: 350, // shifted right to avoid overlap
      y: columnY,
      size: 10,
      font: helveticaFont,
      color: rgb(0.4, 0.4, 0.4),
    });

    // TO Section
    firstPage.drawText("TO", {
      x: 320,
      y: 220,
      size: 12,
      font: helveticaBoldFont,
      color: rgb(0.5, 0.5, 0.5),
    });

    firstPage.drawText(data.to.name, {
      x: 320,
      y: 200,
      size: 12,
      font: helveticaBoldFont,
      color: rgb(0, 0, 0),
    });

    firstPage.drawText(data.to.email, {
      x: 320,
      y: 185,
      size: 10,
      font: helveticaFont,
      color: rgb(0, 0, 0),
    });

    // FROM Section
    firstPage.drawText("FROM", {
      x: 80,
      y: 220,
      size: 12,
      font: helveticaBoldFont,
      color: rgb(0.5, 0.5, 0.5),
    });

    firstPage.drawText(data.from.name, {
      x: 80,
      y: 200,
      size: 12,
      font: helveticaBoldFont,
      color: rgb(0, 0, 0),
    });

    firstPage.drawText(data.from.email, {
      x: 80,
      y: 185,
      size: 10,
      font: helveticaFont,
      color: rgb(0, 0, 0),
    });

    // Wrapping the address dynamically
    const addressLines = wrapText(data.from.address, 200, helveticaFont, 10);
    let addressY = 170;
    addressLines.forEach((line) => {
      firstPage.drawText(line, {
        x: 80,
        y: addressY,
        size: 10,
        font: helveticaFont,
        color: rgb(0, 0, 0),
      });
      addressY -= 15;
    });

    const editedPdfBytes = await pdfDoc.save();
    return editedPdfBytes;
  } catch (error) {
    console.error("Failed to edit the PDF. Please try again.", error);
    return null;
  }
};

export default editPdf;
